import { render, staticRenderFns } from "./QuestionnairesTab.vue?vue&type=template&id=07778b3c&scoped=true"
import script from "./QuestionnairesTab.vue?vue&type=script&lang=js"
export * from "./QuestionnairesTab.vue?vue&type=script&lang=js"
import style0 from "./QuestionnairesTab.vue?vue&type=style&index=0&id=07778b3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07778b3c",
  null
  
)

export default component.exports